import api from './client'

export const mailAgentsApi = {
  list: () => api.get('/api/mail-agents'),
  create: (data) => api.post('/api/mail-agents', data),
  update: (id, data) => api.put(`/api/mail-agents/${id}`, data),
  delete: (id) => api.delete(`/api/mail-agents/${id}`),
}
